import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import Typography from "@mui/material/Typography";
// Limitless imports
import { useTranslation } from "@limitless/common/hooks/translation/TranslationContext";
import NumberRatingSystem from "../csat-footer/number-rating-system/NumberRatingSystem";
import CustomerButton from "../../customer-button/CustomerButton";
const useStyles = makeStyles({
  npsContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: "16px 0"
  },
  clientReviewTitle: {
    marginTop: 16,
    marginBottom: 16,
    marginLeft: 24,
    marginRight: 24,
    textAlign: "center"
  },
  heading: {
    width: 260
  },
  buttonContainer: {
    marginTop: 8,
    alignSelf: "center"
  }
});
const NPSScreen = ({
  message,
  onSubmitScore
}) => {
  var _message$custClientRe;
  const classes = useStyles();
  const {
    t
  } = useTranslation();
  const isRTL = document.documentElement.getAttribute("dir") === "rtl";
  const formatTextForRTL = (text, isRTL, ...variables) => isRTL ? `\u202A${t(text, ...variables)}\u202C` : t(text, ...variables);
  const [scale, setScale] = React.useState((_message$custClientRe = message.custClientReview) === null || _message$custClientRe === void 0 ? void 0 : _message$custClientRe.score);
  const [disableButton, setDisableButton] = React.useState(false);
  const {
    groupName
  } = message;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.npsContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.clientReviewTitle
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2"
  }, formatTextForRTL("How likely are you to recommend {0} Customer Service?", isRTL, groupName))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(NumberRatingSystem, {
    max: 10,
    compact: true,
    rating: scale,
    onClick: newRating => setScale(newRating)
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.buttonContainer
  }, /*#__PURE__*/React.createElement(CustomerButton, {
    onClick: () => {
      setDisableButton(true);
      onSubmitScore(scale);
    },
    id: "numberRatingNextButton",
    disabled: typeof scale !== "number" || disableButton,
    style: {
      width: 100
    }
  }, "Next")));
};
NPSScreen.propTypes = {
  message: PropTypes.object.isRequired,
  onSubmitScore: PropTypes.func.isRequired
};
export default NPSScreen;